module.exports = __webpack_public_path__ + "img/my.ad567817.svg";